import axios from 'axios';
import UserDetails from "../../components/UserDetails/UserDetails";

const apiUrl = process.env.REACT_APP_API_URL;

export interface UserFilters {
    username?: string;
    role?:string;
    state?:string;
}

interface UserDetails {
    username: string;
    fullName: string;
    role: string;
    state: string;
    email: string;
    mainPhone: string;
    secondaryPhone: string;
}

export const getUsers = async (page:number, filters: UserFilters) => {
    try {
        const response = await axios.get(`${apiUrl}/users`, {params: {page, size: 10, ...filters},withCredentials: true});
        const transformedUsers = response.data.data.users.content.map((user: any) => ({
            USUARIO: user.username,
            NOMBRE: user.fullName,
            ROL: user.role,
            ESTADO: user.state
        }))
        return {
            users: transformedUsers || [],
            page: response.data.data.users.number,
            totalPages: response.data.data.users.totalPages,
        };
    } catch (error: any) {
        throw error;
    }
};

export const getUserByUsername = async (username:string) => {
    try {
        const response = await axios.get(`${apiUrl}/users/username/${username}`, {withCredentials: true});
        return response.data.data.user;
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data?.message || 'Error');
        } else if (error.request) {
            throw new Error('Error al obtener usuario del servidor.');
        } else {
            throw new Error('Ocurrió un error');
        }
    }
}

export const updateUserByUsername = async (originalUsername:any, userInfoDTO: UserDetails) => {
    try {
        return await axios.put(`${apiUrl}/users/username/${originalUsername}`, userInfoDTO, {withCredentials: true});
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data?.message || 'Error al actualizar el usuario.');
        } else if (error.request) {
            throw new Error('No hay respuesta del servidor');
        } else {
            throw new Error(error.message || 'Ocurrió un error');
        }
    }
};

export const requestPasswordChangeToken = async (username: string) => {
    try {
        return await axios.post(`${apiUrl}/users/reset-password`, {username: username}, {withCredentials: true});
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data?.message || 'Error al solicitar cambio de contraseña.');
        } else if (error.request) {
            throw new Error('No hay respuesta del servidor');
        } else {
            throw new Error(error.message || 'Ocurrió un error');
        }
    }
}

export const changePassword = async (token: string, newPassword: string) => {
    try{
        return await axios.put(`${apiUrl}/users/confirm-reset-password`, { token, newPassword }, {withCredentials: true});
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data?.message || 'Error al hacer cambio de contraseña.');
        } else if (error.request) {
            throw new Error('No hay respuesta del servidor');
        } else {
            throw new Error(error.message || 'Ocurrió un error');
        }
    }
}
